import { useFeatureEnabled } from './useFeatureEnabled';

export function useFeatureStandingOrderReturnSpecification(): boolean {
  return useFeatureEnabled('STANDING_ORDER_RETURN_SPEC');
}
